<template>
    <div :id="id">
      <div class="clearfix pt05x pb05x lh15">
          <div class="dpIB dpIB_E">
              <span class="w20x-min">{{data.sn}}</span>
              <div>
                  <MyRadio class="dpIB mr2x " :name="'intent'+id" v-model="data.autoDiscovery" :label="true" @change="data.modeChange=false" v-if="data.defaultDiscovery">{{getLanguageStr("plant9","自动添加子设备")}}</MyRadio>
                  <MyRadio class="dpIB" :name="'intent'+id" v-model="data.autoDiscovery" :label="false" @change="showD">{{getLanguageStr("word1620","手动添加子设备")}}</MyRadio>
              </div>
          </div>
          <button :title="$t('cmd108',['点击展开/收起'])" type="button" :class="{transform:data.modeChange}" class="fR fa fa-angle-double-right hover-c-main fs16x mr05x cSub tra" @click="operateModeChange" v-if="!data.autoDiscovery && buttonType !=='add'"></button>
      </div>
	      <!--手动添加子设备-->
	      	<NewDevice :data="data" @update="update" ref="newDevice" @hide="hide" v-show="data.modeChange" :initList="temp"></NewDevice>
	       <div v-show="data.modeChange"><button :class="{'disable':temp.length==0}" class="fR functionBtn" :title="getLanguageStr('cmd12','确定')" @click="makeSure">{{getLanguageStr('cmd12','确定')}}({{temp.length}})</button></div>
    </div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js'
import MyRadio from '@/components/common/ui/Radio'
import * as lib from '@/util/lib.js'
import NewDevice from './NewDevice'
export default {
  name: 'addDeviceLine',
  components: {MyRadio,NewDevice},
  props: {
    id: {
      type: Number
    },
    data: {
      type: Object
    },
    buttonType: {
      type: String,
      default: 'add'
    },
    timezone:{
      type:String,
      default:stage.time.timeZoneCode
    }
  },
  data () {
    return {
    	temp:[]
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    timeFormat: lib.timeFormat,
    update(data,arrayData){
    	this.temp=arrayData;
    	this.data.subDeviceIds=data;
    },
    makeSure(){
    	this.$emit('devices')
    },
    showD(){
    	this.data.modeChange=true;
    	this.$refs.newDevice.show(false)
    },
    hide(){
    	this.$emit('hide')
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/AddDevice/AddDeviceLine.vue